import util from "@/common/js/util";
export default {
    //登录记录 登录登出
    logInOut:[
        {'label':'登录','value':1},
        {'label':'登出','value':2},
    ],
    entrustedBuss:[
        {'label':'FOB','value':'FOB'},
        {'label':'CFR','value':'CFR'},
        {'label':'CIF','value':'CIF'},
        {'label':'EDQ','value':'EDQ'},
        {'label':'DAP','value':'DAP'},
        {'label':'DDU','value':'DDU'},
        {'label':'DDP', 'value':'DDP'},
        {'label':'LDP','value':'LDP'},
        {'label':'跨境物流','value':'DTD'},
        {'label':'进口','value':'JK'},
        {'label':'尾程','value':'EJ'},
    ],
    //地址管理 来源
    addressSourceType:[
        {'label':'平台','value':1},
        {'label':'自建','value':2},
    ],
    boolSelectOptions:[
        {'label':'是','value':true},
        {'label':'否','value':false},
    ],
    intBoolSelectOptions:[
        {'label':'是','value':1},
        {'label':'否','value':0},
    ],
    intBoolSelectOptionsForContains:[
        {'label':'包含','value':1},
        {'label':'不包含','value':0},
    ],
    boolSelectOptionsForContains:[
        {'label':'包含','value':true},
        {'label':'不包含','value':false},
    ],
    abnormalOrderStatusType:[
        {label:'已接收',value:0},
        {label:'已发起',value:1},
        {label:'已完结',value:2},
    ],
    // 散货整柜常量
    goodsTypes: [
        {value: 1, label: "整柜"},
        {value: 2, label: "散货"},
    ],
    //产品来源
    serviceSource: [
    {value: 1, label: "线下供应商"},
    {value: 2, label: "线上供应商"},
    {value: 3, label: "自有产品"},
    ],

    //产品来源
    isUpShelf: [
        {value: 0, label: "下架"},
        {value: 1, label: "上架"},
    ],
    shipping: [
        {value: 'SEA', label: "海运"},
        {value: 'RAILWAY', label: "铁路"},
        {value: 'AIR', label: "空运"},
        {value: 'MORE', label: "多式联运"}
    ],
    shippingTypes: [
        {value: 'SEA', label: "海运"},
        {value: 'RAILWAY', label: "铁路"},
        {value: 'AIR', label: "空运"},
        {value: 'LAND', label: "陆运"},
        {value: 'MORE', label: "多式联运"},
    ],
    // 付款账期
    paymentPeriod: [
        '开票日期',
        '订单月份末日',
    ],
    // 拜访方式
    visitMethod: [
        '线上视频',
        '线下拜访',
    ],
    typeName:{
        add:'创建',
        edit:'编辑',
        view:'查看',
    },
    dateType: [
        {code: 1, name: '离港日'}, {code: 2, name: '离港周'}, {code: 3, name: '离港月'},
        {code: 4, name: '实际送达日'}, {code: 5, name: '实际送达周'}, {code: 6, name: '实际送达月'},
        {code: 7, name: '入国内仓日'}, {code: 8, name: '入国内仓周'}, {code: 9, name: '入国内仓月'}
    ],
    //汇率维护 类型
    exchangeRateType: [
        {label: '全部',value: 'all'},
        {label: '收入',value: 'income'},
        {label: '支出',value: 'disburse'},
    ],
    //汇率维护 状态
    exchangeRateState: [
        {label:'启用','value':true},
        {label:'禁用','value':false},
    ],
    //账号 状态
    accountState: [
        {label:'启用','value':1},
        {label:'禁用','value':0},
    ],
    sexType:[
        {'label':'男','value':0},
        {'label':'女','value':1},
    ],
    fastReceiveStatusType:[
        {label:'未接单',value:'NOT_RECEIVE'},
        {label:'已接单',value:'RECEIVE'},
    ],
    wcReceiveStatusType: [
        {label: '未接单', value: 'NOT_RECEIVE'},
        {label: '接单中', value: 'RECEIVING'},
        {label: '已接单', value: 'RECEIVED'},
    ],
    wcSendType: [
        {label: '直送', value: 'DIRECTLY'},
        {label: '派送', value: 'DISTRIBUTED'},
    ],
    //我的业绩 状态
    myPerformanceState: [
        {label:'待发起','value':1},
        {label:'审核中','value':2},
        {label:'未通过','value':3},
        {label:'已通过','value':4},
    ],
    // 用户状态
    customer_state: [
        {label:"未准入", value: 0},
        {label:"已准入", value: 1}
    ],
    // 报价单状态
    quotationState: [
        {label:"未转委托单", value: 0},
        {label:"已转委托单", value: 1}
    ],
    blur(row, column, cell, event) {
        cell.querySelector(":focus")?.blur();
    },
    typeInfo: {
        personInCharge: {name: '负责人员', code: 1},
        customerServicePersonnel: {name: '客服人员', code: 2},
        operator: {name: '操作人员', code: 3},
        financePerson: {name: '财务人员', code: 4},
        overseasCustomerService: {name: '海外客服', code: 5},
        teams: {name: '团队人员', code: 6},
        salesPerson: {name: '销售人员', code: 7},
    },
    //提成规则 日期
    royaltyRuleDateList1: [
        {label: '核销日期',value: '1'},
    ],
    symbolList1: [
        {label: '+',value: '+'},
        {label: '-',value: '-'},
    ],
    royaltyRuleDateList2: [
        {label: '截止收款日期',value: '2'},
        {label: '实际离港日(当月最后一天)',value: '3'},
        {label: '实际送达日(当月最后一天)',value: '4'},
        {label: '实际离港日',value: '5'},
        {label: '实际离港月',value: '6'},
    ],
    symbolList2: [
        {label: '>',value: '>'},
        {label: '<',value: '<'},
        {label: '=',value: '='},
        {label: '>=',value: '>='},
        {label: '<=',value: '<='},
    ],
    //提单确认数据
    billOfLadingConfirmationStatus:[
        {label: '未确认',value: 'UNCONFIRMED'},
        {label: '待确认',value: 'TO_BE_CONFIRMED'},
        {label: '已确认',value: 'CONFIRMED'},
    ],
    //数据确认数据
    dataValidationStatus:[
        {label: '未确认',value: 'UNCONFIRMED'},
        {label: '待确认',value: 'TO_BE_CONFIRMED'},
        {label: '已确认',value: 'CONFIRMED'},
    ],
    //接单状态
    receivingStatus:[
        {label: '未接单',value: 'NOT_RECEIVE'},
        {label: '接单中',value: 'RECEIVING'},
        {label: '客服接单',value: 'RECEIVED'},
        {label: '操作接单',value: 'OPERATOR_RECEIVED'},
        {label: '退关',value: 'CANCELED'},
    ],
    zxReceivingStatus: [
        {label: '未接单', value: 'NOT_RECEIVE'},
        {label: '接单中', value: 'RECEIVING'},
        {label: '操作接单', value: 'OPERATOR_RECEIVED'},
        {label: '退关', value: 'CANCELED'},
    ],
    ejFclServices:[
        {'label': '清关服务', 'value': 'QGFW'},
        {'label': '尾程卡车', 'value': 'WCKC'},
    ],
    ejBulkServices:[
        {'label': '清关服务', 'value': 'QGFW'},
        {'label': '尾程卡车', 'value': 'WCKC'},
        {'label': '尾程拆柜', 'value': 'WCCG'},
    ],
    serviceIds:[
        {'label': '国内卡车', 'value': 'GNKC'},
        {'label': '报关服务', 'value': 'GNBG'},
        {'label': '国际保险', 'value': 'GJBX'},
        {'label': '海运服务', 'value': 'SEA'},
        {'label': '铁路服务', 'value': 'RAILWAY'},
        {'label': '空运服务', 'value': 'AIR'},
        {'label': '多式联运', 'value': 'MORE'},
        {'label': '清关服务', 'value': 'QGFW'},
        {'label': '尾程卡车', 'value': 'WCKC'},
        {'label': '尾程快递', 'value': 'WCKD'},
        {'label': '尾程派送', 'value': 'WCPS'},
        {'label': '尾程拆柜', 'value': 'WCCG'},
        {'label': '尾程自提', 'value': 'WCZT'},
        {'label': 'DAP门点服务', 'value': 'DAP'},
        {'label': 'DDP门点服务', 'value': 'DDP'},
        {'label': 'DDU门点服务', 'value': 'DDU'},
        {'label': 'LDP门点服务', 'value': 'LDP'},
        {'label': '卡派', 'value': 'KP'},
        {'label': '海派', 'value': 'HP'},
        {'label': '海卡', 'value': 'HK'},
        {'label': '空派', 'value': 'KONGP'},
        {'label': '卡航', 'value': 'KH'},
        {'label': '铁派', 'value': 'TP'},
        {'label': '国际快递', 'value': 'GJKD'},
        {'label': '跨境保险', 'value': 'KJBX'}
    ],
    writeOffStatusInt: [
        {value: 0, label: "未核销"},
        {value: 1, label: "已核销"},
    ],
    bjdToWcState: [
        {label: "未转尾程订单", value: 0},
        {label: "已转尾程订单", value: 1}
    ],
    wcBusinessStatus: [
        {label: "ISF申报", value: 1},
        {label: "ISF匹配", value: 5},
        {label: "清关资料已发送", value: 6},
        {label: "清关中", value: 2},
        {label: "查验中", value: 3},
        {label: "已放行", value: 4},
        {label: "已拆柜", value: 7},
        {label: "已还空", value: 8},
    ],
    confirmCostInt:[
        {value: 0, label: "未确认"},
        {value: 1, label: "已确认"},
    ],
    costLockInt:[
        {value: 0, label: "未锁定"},
        {value: 1, label: "已锁定"},
    ],
    costLockBool:[
        {value: false, label: "未锁定"},
        {value: true, label: "已锁定"},
    ],
    costBillInt:[
        {value: 0, label: "未开票"},
        {value: 1, label: "已开票"},
    ],
    costDetailInt:[
        {value: 0, label: "收入"},
        {value: 1, label: "支出"},
    ],
    costIncomeWriteOffStr:[
        {value: "NO_DATA", label: "无数据"},
        {value: "UNCONFIRMED", label: "收款中"},
        {value: "CONFIRMED", label: "已核销"},
    ],
    wcDeliveryMethod: [
        {label: "客户自提", value: "客户自提"},
        {label: "快递自提", value: "快递自提"},
        {label: "亚马逊自提", value: "亚马逊自提"},
        {label: "卡派", value: "卡派"},
        {label: "UPS站点", value: "UPS站点"},
        {label: "Fedex站点", value: "Fedex站点"},
        {label: "USPS站点", value: "USPS站点"},
        {label: "Truck-Amazon", value: "Truck-Amazon"},
        {label: "Truck-Other", value: "Truck-Other"},
        {label: "其他", value: "其他"},
        {label: "暂存", value: "暂存"},
    ],
    // 服务打包组，以打包方式对外展示
    serviceIdGroups:[
        {'value': 'DTD', label:'跨境物流', members:['KP', 'HP', 'HK', 'KONGP', 'KH', 'TP', 'GJKD']}
    ],
    //清关资料或者ISF资料确认状态
    qgStatusType:[
        {'label': '未上传', 'value': 0},
        {'label': '未确认', 'value': 1},
        {'label': '部分确认', 'value': 2},
        {'label': '已确认', 'value': 3},
    ],
    oldLogObj:[],
    util
}



// WEBPACK FOOTER //
// ./src/common/js/globalData.js